module.exports = __webpack_public_path__ + "edceae61c8363764d08a2b8f81f833e8.jpg";